import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object extends default clientScheme used for UploadZone */
const UploadReworkZoneScheme = Yup.object().shape({
    attachment: Yup.array()
        .of(
            Yup.object()
                .shape({
                    name: Yup.string()
                        .required()
                        .matches(
                            /^[^+]+\.(pdf|doc|docx|PDF|DOC|DOCX)$/,
                            'Filetype Should be PDF, DOC and DOCX'
                        ),
                })
                .required('File required')
        )
        .required('Upload file needed'),
});

export { UploadReworkZoneScheme };
